import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-primary to-secondary">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-primary-foreground mb-4">
            Ready for Superior Coating Performance?
          </h2>
          <p className="text-lg lg:text-xl max-w-3xl mx-auto text-orange-300">
            Experience the difference of precision chemistry and systematic quality control. Let's discuss your coating requirements.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-6 border border-primary-foreground/20">
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center mb-4">
              <Icon name="ClockIcon" size={24} variant="solid" className="text-accent-foreground" />
            </div>
            <h3 className="text-xl font-headline font-bold text-primary-foreground mb-2">
              Fast Turnaround
            </h3>
            <p className="text-sm text-orange-300">
              24-48 hour typical turnaround for standard coating projects with rush service available
            </p>
          </div>

          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-6 border border-primary-foreground/20">
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center mb-4">
              <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-accent-foreground" />
            </div>
            <h3 className="text-xl font-headline font-bold text-primary-foreground mb-2">
              Quality Guaranteed
            </h3>
            <p className="text-sm text-orange-300">
              ISO 9001:2015 certified processes with comprehensive testing and documentation
            </p>
          </div>

          <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-lg p-6 border border-primary-foreground/20">
            <div className="w-12 h-12 bg-accent rounded-lg flex items-center justify-center mb-4">
              <Icon name="SwatchIcon" size={24} variant="solid" className="text-accent-foreground" />
            </div>
            <h3 className="text-xl font-headline font-bold text-primary-foreground mb-2">
              Custom Solutions
            </h3>
            <p className="text-sm text-orange-300">
              Color matching, specialty coatings, and custom chemistry formulations available
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/homepage"
            className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-accent text-accent-foreground rounded-md font-cta font-bold hover:opacity-90 transition-all duration-base shadow-lg">

            <Icon name="DocumentTextIcon" size={20} variant="outline" />
            <span>Request Coating Quote</span>
          </Link>

          <Link
            href="/quality-iso-hub"
            className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground border-2 border-primary-foreground/30 rounded-md font-cta font-bold hover:bg-primary-foreground/20 transition-all duration-base">

            <Icon name="ClipboardDocumentCheckIcon" size={20} variant="outline" />
            <span>View Quality Documentation</span>
          </Link>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-foreground/20 text-center">
          <p className="text-sm mb-4 text-orange-500">
            Need technical specifications or have questions about coating chemistry?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="flex items-center space-x-2 text-primary-foreground">
              <Icon name="PhoneIcon" size={20} variant="outline" />
              <span className="text-sm font-cta font-semibold">+84 27 4730 3090</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-primary-foreground/20" />
            <div className="flex items-center space-x-2 text-primary-foreground">
              <Icon name="EnvelopeIcon" size={20} variant="outline" />
              <span className="text-sm font-cta font-semibold">info@fusionfinishing.net</span>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default CTASection;